import React from 'react';
import Image from 'next/image';
import { cx } from 'styled-system/css';
import { media } from 'styled-system/recipes';

interface MediaProps {
  src: string;
  alt: string;
  className?: string;
  style?: React.CSSProperties;
  /** `sizes` for responsive images (defaults to a third of the page) */
  sizes?: string;
  priority?: boolean;
}

const isVideo = (src: string) => /\.(mp4|webm)$/i.test(src);

/**
 * A framed screenshot (or screen recording) that fills its box: set the size or aspect ratio
 * with `className`. Zooms slowly when its card is hovered.
 */
export function Media({
  src,
  alt,
  className,
  style,
  sizes = '(min-width: 992px) 33vw, 100vw',
  priority,
}: MediaProps) {
  return (
    <div className={cx(media(), className)} style={style}>
      {isVideo(src) ? (
        <video src={src} autoPlay muted loop playsInline aria-label={alt} />
      ) : (
        <Image
          src={src}
          alt={alt}
          fill
          sizes={sizes}
          priority={priority}
          unoptimized={src.endsWith('.gif')}
        />
      )}
    </div>
  );
}
